import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  'licensetableLicensesViewLabel': {
    id: 'license.table.view.licenses.label',
    description: 'Label for license table license -view',
    defaultMessage: 'Licenses',
  },
  'licensetableBillingViewLabel': {
    id: 'license.table.view.billing.label',
    description: 'Label for license table billing -view',
    defaultMessage: 'Billing',
  },
  'licensetableViewTitle': {
    id: 'license.table.view.title',
    description: 'Label for license table view',
    defaultMessage: 'View',
  },
  'searchInputPlaceholder': {
    id: 'license.table.search.input.placeholder',
    description: 'Placeholder text for license table search',
    defaultMessage: 'Search...',
  },
  'dateFromInputPlaceholder': {
    id: 'license.table.dateFrom.input.placeholder',
    description: 'Placeholder text for license table dateFrom',
    defaultMessage: 'Starting from',
  },
  'dateToInputPlaceholder': {
    id: 'license.table.dateTo.input.placeholder',
    description: 'Placeholder text for license table dateTo',
    defaultMessage: 'Ending to',
  },
  'exportLicensesButtonLabel': {
    id: 'license.table.export.licenses.button.label',
    description: 'Label for license export button',
    defaultMessage: 'Export licenses',
  },
  'exportBillingButtonLabel': {
    id: 'license.table.export.billing.button.label',
    description: 'Label for license billing export button',
    defaultMessage: 'Export billing',
  }
});
